export const ROUTES = {
    DASHBOARD: {
        route: 'promo-video-maker-dashboard',
        key: 'dashboard',
    },
    LOGIN: {
        route: 'promo-video-maker-login',
        key: 'login',
    },
    SETTINGS: {
        route: 'promo-video-maker-oauth-settings',
        key: 'settings',
    },
};
